module.exports = __webpack_public_path__ + "img/trees-right.1ae290ff.png";